import type { NetworkState } from './_state.type';

/** Network State. */
export const networkState: NetworkState = {
  network: {
    offline: false,
    error: false,
  },
};
